import { Injectable } from '@angular/core';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class TipoParadaService extends ServiceBase {

  private baseUrlService: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/cruzamento_tipo_parada`;
  }

  public getTipoParada(): Promise<any> {
    return this.get([]);
  }

  public adicionarTipoParada(nome: string): Promise<any> {
    const url = this.getURL();
    const body = { descParadaFab: nome };
    const options = (this as any).getOptions();
    
    return (this as any).http.post(url, body, options).toPromise().then((this as any).tratarRetorno);
  }

  public removerTipoParada(id: number): Promise<any> {
    const url = `${this.getURL()}?idTipoParada=${id}`;
    const options = (this as any).getOptions();
    
    return (this as any).http.delete(url, options).toPromise().then((this as any).tratarRetorno);
  }

  public atualizarTipoParada(id: number, nome: string): Promise<any> {
    const parametros = [{ nome: 'idTipoParada', valor: id.toString() }];
    const body = { descParadaFab: nome };
    
    return this.atualizar(body, parametros);
  }

  public getTipoParadaPorId(id: number): Promise<any> {
    const parametros = [
      { nome: 'idTipoParada', valor: id.toString() }
    ];
    return this.get(parametros);
  }

  public getVinculosTipoParada(idTipoParada: number): Promise<any> {
    const url = `${this.getURL()}/vinculos?idTipoParada=${idTipoParada}`;
    const options = (this as any).getOptions();
    
    return (this as any).http.get(url, options).toPromise().then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro na requisição de vínculos:', error);
        throw error;
      });
  }

  public salvarVinculosTipoParada(idTipoParada: number, elementosVinculados: any[]): Promise<any> {
    const url = `${this.getURL()}/vincular?idTipoParada=${idTipoParada}`;
    const body = {
      descTipoParadas: elementosVinculados.map(elemento => ({
        descTipoParada: elemento.nome
      }))
    };
    const options = (this as any).getOptions();
    
    return (this as any).http.post(url, body, options).toPromise().then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro ao salvar vínculos:', error);
        throw error;
      });
  }
}
